import { cn } from '@/lib/utils';
import { useMemo } from 'react';

import { useChatSession, useConfig } from '@chainlit/react-client';

import FonMark from '@/components/FonMark';
import MaterialIcon from '@/components/MaterialIcon';

interface Props {
  author?: string;
  hide?: boolean;
  isError?: boolean;
  isLoading?: boolean;
}

const MessageAvatar = ({ author, hide, isError, isLoading }: Props) => {
  const { chatProfile } = useChatSession();
  const { config } = useConfig();

  const selectedChatProfile = useMemo(() => {
    return config?.chatProfiles.find((profile) => profile.name === chatProfile);
  }, [config, chatProfile]);

  if (isError) {
    return (
      <div className="w-9 h-9 rounded-lg bg-error/20 flex items-center justify-center flex-shrink-0">
        <MaterialIcon name="error" className="text-error" />
      </div>
    );
  }

  return (
    <span className={cn('inline-block flex-shrink-0', hide && 'invisible')}>
      <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0">
        <FonMark
          alt={
            selectedChatProfile?.name || config?.ui.name || author || 'FONGPT'
          }
          className={cn('h-6 w-6', isLoading && 'fongpt-logo-loading')}
        />
      </div>
    </span>
  );
};

export { MessageAvatar };
